/* Qik Joe — the temperature finder (zone 02)

   The primary way into the catalogue. Drag along the axis and the list
   resolves to the products actually rated for that cold.

   Built on a native <input type="range"> so it is keyboard operable and
   announced correctly without reimplementing any of that. The custom track,
   ticks and readout are drawn behind it; the input itself stays in the
   accessibility tree with a real aria-valuetext.

   The axis runs warm-to-cold left-to-right, which is the opposite of the
   input's own direction, so everything goes through toTemp()/toSlider(). */

(function () {
  'use strict';

  function Finder(root) {
    this.root = root;
    this.input = root.querySelector('[data-tf-input]');
    if (!this.input) return;

    this.readout = root.querySelector('[data-tf-readout]');
    this.count = root.querySelector('[data-tf-count]');
    this.fill = root.querySelector('[data-tf-fill]');
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-tf-item]'));

    this.max = parseInt(root.getAttribute('data-tf-max'), 10);   // warmest, e.g. 32
    this.min = parseInt(root.getAttribute('data-tf-min'), 10);   // coldest, e.g. -25

    this.note = root.querySelector('[data-tf-note]');
    this.onInput = this.onInput.bind(this);
    this.input.addEventListener('input', this.onInput);

    // The local-conditions section publishes tonight's low. Starting the
    // finder on the cold this visitor is actually getting is the whole point
    // of having both on the page — but only until they touch the control
    // themselves, after which their choice stands.
    this.touched = false;
    this.input.addEventListener('input', function () { this.touched = true; }.bind(this));
    document.addEventListener('qj:forecast', this.onForecast.bind(this));

    this.onInput();
  }

  Finder.prototype.onForecast = function (event) {
    if (this.touched) return;
    var d = event.detail || {};
    if (typeof d.low !== 'number') return;

    var where = d.place ? ' in ' + d.place : '';

    // A low above the warm end of the axis is not a cold to shop for. Clamping
    // it to 32° and calling it "tonight's low" would be a lie on the face of
    // the control, so say the true thing instead and leave the axis alone.
    if (d.low > this.max) {
      if (this.note) {
        this.note.textContent = 'Nothing to melt tonight' + where + ' — it is ' + d.low + '°F.';
        this.note.hidden = false;
      }
      return;
    }

    var temp = Math.max(this.min, d.low);
    this.input.value = this.max - temp;
    this.onInput();

    if (this.note) {
      var capped = d.low < this.min
        ? 'Tonight’s low' + where + ' is ' + d.low + '°F, past the end of this scale.'
        : 'Set to tonight’s low' + where + '.';
      this.note.textContent = capped;
      this.note.hidden = false;
    }
  };

  // Slider position 0..(max-min) maps to temperature max..min.
  Finder.prototype.toTemp = function (pos) {
    return this.max - pos;
  };

  Finder.prototype.onInput = function () {
    var pos = parseInt(this.input.value, 10);
    var temp = this.toTemp(pos);
    var span = this.max - this.min;

    if (this.readout) this.readout.textContent = temp + '°F';
    if (this.fill) this.fill.style.setProperty('--tf-fill', span ? (pos / span) : 0);

    this.input.setAttribute('aria-valuetext', temp + ' degrees Fahrenheit');

    var rated = 0;
    var traction = 0;

    for (var i = 0; i < this.items.length; i++) {
      var item = this.items[i];

      // Traction aids do not melt anything; they are always applicable and
      // are counted separately rather than being scored against the axis.
      if (item.hasAttribute('data-tf-traction')) {
        item.classList.remove('is-out');
        traction++;
        continue;
      }

      var low = parseInt(item.getAttribute('data-tf-low'), 10);
      var works = !isNaN(low) && low <= temp;
      item.classList.toggle('is-out', !works);
      if (works) rated++;
    }

    if (this.count) {
      var total = this.items.length - traction;
      var msg = rated + ' of ' + total + ' ice melts rated for ' + temp + '°F';
      if (traction) {
        msg += ', plus ' + traction + ' traction aid' + (traction > 1 ? 's' : '');
      }
      this.count.textContent = msg;
    }
  };

  function init(root) {
    var nodes = (root || document).querySelectorAll('[data-tf]');
    for (var i = 0; i < nodes.length; i++) new Finder(nodes[i]);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
